import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const messageService = inject(MessageService);
  const authService = inject(AuthService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      let errorMessage = 'Ha ocurrido un error desconocido';

      switch (error.status) {
        case 0:
          errorMessage = 'No se puede conectar al servidor';
          break;
        case 400:
          errorMessage = 'Solicitud incorrecta';
          break;
        case 401:
          errorMessage = 'Sesión expirada o no autorizada';
          authService.logout();
          router.navigate(['/login']);
          break;
        case 403:
          errorMessage = 'No tienes permisos para realizar esta acción';
          router.navigate(['/']);
          break;
        case 404:
          errorMessage = 'Recurso no encontrado';
          break;
        case 500:
          errorMessage = 'Error interno del servidor';
          break;
      }

      if (error.error?.message) {
        errorMessage = error.error.message;
      }

      messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: errorMessage,
        life: 5000
      });

      console.error('Error HTTP:', error);

      return throwError(() => error);
    })
  );
};
